import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PortalService } from '../../services/portal.service';
import { Post } from '../../models/post.model';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatChipInputEvent, PageEvent } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import * as FileSaver from 'file-saver';
import { FormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

@Component({
  templateUrl: './news.page.html',
  styleUrls: ['./news.page.scss']
})
export class NewsPage implements OnInit, OnDestroy {

  posts: Post[];
  filteredPosts: Post[];
  pageSize: number = 10;
  numberOfPosts: number = 0;
  type: string;
  private subscription$ = new Subject();

  separatorKeysCodes: number[] = [ENTER, COMMA];
  tagsCtrl = new FormControl();
  filteredTags: Observable<string[]>;
  selectedTags: string[] = [];
  tagList: string[] = [];
  @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private portalService: PortalService,
    private route: ActivatedRoute) {
    this.filteredTags = this.tagsCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filterTags(fruit) : this.tagList.slice()));
  }

  ngOnInit() {
    this.route.parent.params
      .pipe(takeUntil(this.subscription$))
      .subscribe(({type}) => {
        this.type = type;
        this.getPosts(0, this.pageSize);
      });
  }

  getPosts(pageNumber: number, pageSize: number) {
    this.portalService.getPosts(pageNumber, pageSize, this.type)
      .subscribe(postPage => {
        const tagsSet = new Set();
        this.numberOfPosts = postPage.numberOfPosts;
        this.posts = postPage.posts.map(post => {
          post.dateCreated = new Date(post.dateCreated);
          if(post.tags)
            post.tags.forEach(tag => tagsSet.add(tag));
          return new Post(post.id, post.title, post.content, post.file, post.dateCreated, post.tags);
        });
        this.tagList = Array.from(tagsSet.values());
        this.filteredPosts = [...this.posts];
      });
  }

  changeExpanded(post: Post) {
    post.isExpanded = !post.isExpanded;
  }

  getShortContent(post: Post) {
    return post.content.substr(0, 500) + '...';
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    //this.getPosts(event.pageIndex, event.pageSize);
  }

  downloadFile(post: Post) {
    this.portalService.getPostFile(post.id , post.file.id).subscribe(file => {
      FileSaver.saveAs(file, post.file.fileName);
    })
  }

  ngOnDestroy(): void {
    this.subscription$.next();
    this.subscription$.complete();
  }


  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        this.selectedTags.push(value.trim());
      }
      if (input) {
        input.value = '';
      }
      this.tagsCtrl.setValue(null);
    }
  }

  remove(fruit: string): void {
    const index = this.selectedTags.indexOf(fruit);
    if (index >= 0) {
      this.selectedTags.splice(index, 1);
      this._filterPosts();
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedTags.push(event.option.viewValue);
    this.tagInput.nativeElement.value = '';
    this.tagsCtrl.setValue(null);
    this._filterPosts();
  }

  private _filterTags(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.tagList.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  private _filterPosts(): void {
    if(this.selectedTags.length === 0){
      this.filteredPosts = [...this.posts];
    }
    else {
      this.filteredPosts = this.posts.filter(post => {
        return post.tags && post.tags.filter(tag => this.selectedTags.includes(tag)).length > 0;
      });
    }
  }

}
